(function () {
	'use strict';

	angular
		.module('expo-cupom-digital')
		.controller('MyRescuesController', MyRescuesController)

	/** @ngInject */
	function MyRescuesController($q, UserService, HelperService, sweetAlert) {
		const vm = this;

		let perPageCoupon = 10;
		let currentPageCoupon = 0;
		let userId;

		let couponModal = new bootstrap.Modal($("#coupon-modal"), {
			keyboard: false,
			backdrop: 'static'
		});

		$(couponModal).on('hidden.bs.modal', function (event) {
			vm.showRescue = false;
			vm.openCouponData = null;
		})

		vm.caminhoPastaImagem = (area, id, arquivo) => HelperService.caminhoPastaImagem(area, id, arquivo);

		vm.openRescue = coupon => {
			vm.showRescue = true;
			vm.openCouponData = coupon;

			couponModal.show();
		}

		vm.closeRescue = () => {
			couponModal.hide();
		}

		vm.loadMoreCoupon = () => {
			currentPageCoupon++;

			getCoupons(true);
		}

		init();

		function getCoupons(append = false) {
			let params = {
				perPage: perPageCoupon,
				skip: currentPageCoupon * perPageCoupon,
				orderBy: "id",
				orderDescending: false
			};

			if (vm.currentCategory) {
				params.category = vm.currentCategory;
			}

			return UserService
				.getUserRescues(userId, params)
				.then(
					success => {
						if (!success.errors) {
							if (append == true)
								vm.coupons = vm.coupons.concat(success.Registers)
							else
								vm.coupons = success.Registers
						} else {
							if (success.errors.type == "no_content") {
								vm.coupons = [];
								vm.canLoadMoreCoupon = false;
							} else {
								HelperService.errorCallback(success);
							}
							return;
						}

						if (success.Registers.length < perPageCoupon)
							vm.canLoadMoreCoupon = false;
						else if (currentPageCoupon == success.NumberOfPages - 1)
							vm.canLoadMoreCoupon = false;
						else
							vm.canLoadMoreCoupon = true;
					},
					error => HelperService.errorCallback(error)
				)
		}

		function init() {
			HelperService.startLoading(".content-body");
			vm.canLoadMoreCoupon = false;
			userId = UserService.getUserId();

			getCoupons().then(
				success => HelperService.stopLoading(".content-body"),
				error => {
					HelperService.stopLoading(".content-body");
					HelperService.errorCallback(error)
				}

			)

		}

	}
}());